var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 24.0345V19.5259H4.50287V24.0345C4.50287 25.2795 5.51214 26.2888 6.75718 26.2888H27.7974C29.0425 26.2888 30.0517 25.2795 30.0517 24.0345V19.5259H31.5546V24.0345C31.5546 26.1095 29.8724 27.7917 27.7974 27.7917H6.75718C4.68217 27.7917 3 26.1095 3 24.0345Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5259 22.5316V6H18.0288V22.5316H16.5259Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.2773 23.2831C17.049 23.2831 16.8333 23.1794 16.6906 23.0009L10.6791 15.4866L11.8527 14.548L17.2775 21.3286L22.7023 14.548L23.8757 15.4866L17.8642 23.0009C17.7218 23.1794 17.5057 23.2831 17.2775 23.2831H17.2773Z","key":2})]);
}

IconDownload.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
